import core from './commuCore'
const output = {}

/* —————————————————————— 员工相关api —————————————————————— */

function getStaffPage (query) {
  return core.ajax(query, '/staff/page', 'get')
}
output.getStaffPage = getStaffPage

function updateStaff (condition) {
  return core.ajax(condition, '/staff', 'put')
}
output.updateStaff = updateStaff

export default output
